import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import BookListItem from '../books/components/BookListItem';
import { Pagination } from '../components/Pagination';
import ErrorMessageBox from '../components/ErrorMessageBox';
import { scrollToElement } from '../../lib/userFunctions';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';
import { Loading } from 'app/components/Loading';


export const UserWishBook = ()=>{
    const { school } = useParams();
    const [page, setPage] = useState(0);
    const queryClient = useQueryClient();

    const { data:wishBooks, isFetching, isError, error } =useQuery({
        queryKey:['user/wishBook', page],
        queryFn:()=>Api.get(`/api/book/wish/list?page=${page}`)
    });

    const fetchList = (page=0)=>{
        scrollToElement('lnb');
        setPage(page);
    }


    const deleteMutate = useMutation({
        mutationFn:(isbn)=>Api.get(`/api/book/keep/toggle/${isbn}`),
        onSuccess:(res)=>{
            queryClient.invalidateQueries({queryKey:['user/wishBook', page]});
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    });
    
    const onDeleteKeep = (event)=>{
        event.preventDefault();
        if(deleteMutate.isPending)return;
        if( !window.confirm('관심도서에서 삭제 하시겠습니까?') )return;
        let isbn = event.target.getAttribute('data-isbn');
        deleteMutate.mutate(isbn);
    }

    
    if(isError)return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
    
    return (
        <div className="inner myreading_wishbook">
            <div className="wishbook">
                <div className="book_list">
                    {(wishBooks?.data?.list?.length===0) && <div className="no_data"><p>관심 도서가 없습니다.</p></div>}
                    <ul className="clear">
                        {wishBooks?.data?.list.map( (book)=>{
                            return(
                                <li className="wishItem" key={book.isbn}>
                                    <Link to={`/${school}/book/${book.isbn}`} >
                                        <BookListItem book={book} />
                                        <button  className="btn btn_wish_cancel" data-isbn={book.isbn} onClick={onDeleteKeep} alt="관심" >
                                            제거
                                        </button>
                                    </Link>
                                </li>
                            )
                        }) }
                    </ul>
                    <Loading overlay={true} active={isFetching} />
                </div>
                <Pagination page={wishBooks?.data?.page} totalPage={wishBooks?.data?.totalCount} gotoPage={fetchList} />
            </div>
        </div>
    );
};